import { useCallback, useState } from 'react'
import { Form, Input, Button, Row, Col, Select } from 'antd'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import styles from './styles.module.scss'
import { removeUndefinedValues, removeVietnameseTones } from '../../config-func'
import { debounce } from 'lodash'
const { Option } = Select

const SearchForm = ({
  form,
  pagination,
  fetchData = () => {},
}) => {
  const [expanded, setExpanded] = useState(false)
  const handleSearch = useCallback(
    debounce((allValues) => {
      const { ...data } = allValues
      const params = removeUndefinedValues({
        ...data,
        // acreage_min: acreage,
        // acreage_max: acreage,
        // aarea_outside_min: area_outside,
        // area_outside_max: area_outside,
        current: pagination.current,
        pageSize: pagination.pageSize
      })

      fetchData(params)
    }, 500),
    [pagination.current, pagination.pageSize]
  )

  const handleReset = () => {
    // setFilters({currentPage: 1,
    // pageSize: 10})
    form.resetFields()
    fetchData()
  }
  const fields = [
    { label: 'ID', name: 'id', hidden: !expanded },
    { label: 'Họ tên', name: 'name', hidden: !expanded },
    { label: 'Message', name: 'message', hidden: !expanded },
    { label: 'Điện thoại', name: 'phone_number' },
    { label: 'Trạng thái', name: 'status' },
    { label: 'Kênh gửi', name: 'task_type' },
    { label: 'Thiết bị gửi', name: 'device_code' },
    { label: 'Dự án', name: 'project' },
    { label: 'Số Phòng/Đc', name: 'room_number' },
    { label: 'Số lần gửi', name: 'number_of_send' },
    { label: 'Ngày cập nhật', name: 'updated_at' }
  ]

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      // labelCol={{ span: 8 }}
      // labelAlign="right"
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        if (value.city_code) {
          form.setFieldsValue({
            district_code: null,
            town_code: null
          })
        }
        if (value.district_code) {
          form.setFieldsValue({
            town_code: null
          })
        }
      }}
    >
      {expanded ? (
        <>
          <div className={styles.formAdd}>
            {fields.map((field, index) => (
              <Form.Item
                // labelCol={{ span: 8 }}
                label={field.label}
                name={field.name}
                style={{
                  marginBottom: 8,
                  display: field.hidden == true ? 'none' : 'block'
                }}
                className={styles.formItem}
              >
                {field.type === 'select' ? (
                  <Select
                    style={{ width: '100%' }}
                    placeholder={`Chọn ${field.label}`}
                    onChange={field.onChange}
                    showSearch={true}
                    allowClear={true}
                    filterOption={(input, option) => {
                      const inputValue = removeVietnameseTones(input).toLowerCase();
                      const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                      return optionValue.includes(inputValue);
                    }}
                  >
                    {field.arr && field.arr.length > 0 ? (
                      field.arr.map((item, idx) => (
                        <Option key={idx} value={item.value}>
                          {item.label}
                        </Option>
                      ))
                    ) : (
                      <>
                        {/* <Option value="option1">Option 1</Option>
                        <Option value="option2">Option 2</Option> */}
                      </>
                    )}
                  </Select>
                ) : (
                  // <Input placeholder={`Nhập ${field.label}`} />
                  <Input
                    placeholder={`Nhập ${field.label.toLowerCase()}`}
                    onBlur={(e) => {
                      form.setFields([
                        {
                          name: field.name,
                          value: e.target.value?.trim()
                        }
                      ])
                    }}
                  />
                )}
              </Form.Item>
            ))}
            <Form.Item label="" name="" className={styles.formItem}></Form.Item>
            <div
              className={styles.formItem}
              style={{ textAlign: 'right', marginBottom: 8 }}
            >
              <Button onClick={handleReset}>Đặt lại</Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ margin: '0 8px' }}
              >
                Tìm kiếm
              </Button>
              <span
                className="d-flex"
                style={{ color: '#08c', cursor: 'pointer' }}
                onClick={() => setExpanded(!expanded)}
              >
                Thu nhỏ{' '}
                <UpOutlined style={{ fontSize: '14px', color: '#08c' }} />
              </span>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            // display: 'flex',
            // margin: '-0 8px',
            // justifyContent: 'space-between'
            display: 'flex',
            // margin: '-0 8px',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            // gap: 16,
            alignItems: 'center'
          }}
        >
          <Form.Item label="ID" name="id" className={styles.formItem}>
            <Input
              placeholder="Nhập ID"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'id',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <Form.Item
            label="Tên khách hàng"
            name="name"
            className={styles.formItem}
          >
            <Input
              placeholder="Nhập Tên khách hàng"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'name',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <Form.Item
            label="Điện thoại"
            name="phone_number"
            className={styles.formItem}
          >
            <Input
              placeholder="Nhập Điện thoại"
              onBlur={(e) => {
                form.setFields([
                  {
                    name: 'phone_number',
                    value: e.target.value?.trim()
                  }
                ])
              }}
            />
          </Form.Item>
          <div
            className={styles.formItem}
            style={{ textAlign: 'right', marginTop: 6 }}
          >
            <Button onClick={handleReset}>Đặt lại</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: '0 8px' }}
            >
              Tìm kiếm
            </Button>
            <span
              className="d-flex"
              style={{ color: '#08c', cursor: 'pointer' }}
              onClick={() => setExpanded(!expanded)}
            >
              Mở rộng{' '}
              <DownOutlined style={{ fontSize: '14px', color: '#08c' }} />
            </span>
          </div>
          {/* )} */}
        </div>
      )}
    </Form>
  )
}

export default SearchForm
